<template>
  <v-app class="ts-home">
    <!-- HERO -->
    <section v-if="cargado">
      <Carousel :items="imagenesEventoCarousel" :redirect="true"></Carousel>
    </section>
    <section v-else class="ts-hero-skeleton">
      <v-skeleton-loader type="image" dark></v-skeleton-loader>
    </section>

    <!-- BENEFICIOS -->
    <section class="ts-container">
      <div class="ts-features">
        <div class="ts-feature" v-for="(item, i) in beneficios" :key="i">
          <i class="material-icons ts-feature-icon">{{ item.icono }}</i>
          <div>
            <h6>{{ item.titulo }}</h6>
            <p>{{ item.texto }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- PROXIMOS EVENTOS (se oculta si ya cargó y no hay eventos) -->
    <section class="ts-container ts-section" v-if="!cargado || proximosEventos.length">
      <div class="ts-section-head">
        <h2 class="ts-title">Próximos <span>eventos</span></h2>
        <a href="#eventos" class="ts-ver-todos" @click.prevent="scrollA('eventos')">
          Ver todos <i class="material-icons">arrow_forward</i>
        </a>
      </div>
      <div class="ts-grid" v-if="proximosEventos.length">
        <EventoCard v-for="evento in proximosEventos" :key="'prox-' + evento.id" :evento="evento"></EventoCard>
      </div>
      <div class="ts-grid" v-else>
        <v-skeleton-loader v-for="n in 4" :key="n" type="image" class="ts-card-skeleton"></v-skeleton-loader>
      </div>
    </section>

    <!-- BANNERS DESTACADOS (administrables) -->
    <section class="ts-container ts-destacados" v-if="bannersDestacados.length">
      <a
        v-for="(banner, i) in bannersDestacados"
        :key="'banner-' + i"
        :href="banner.url_evento"
        :title="banner.nombre_evento"
        class="ts-destacado"
      >
        <img :src="banner.banner_desktop" :alt="banner.nombre_evento" class="d-none d-md-block">
        <img :src="banner.banner_movil" :alt="banner.nombre_evento" class="d-block d-md-none">
      </a>
    </section>

    <!-- EXPERIENCIAS -->
    <section class="ts-experiencias">
      <div class="ts-experiencias-inner">
        <h2 class="ts-experiencias-title">
          Experiencias
          <span>que nos unen</span>
        </h2>
        <div class="ts-experiencias-brand">
          <img src="/images/logo-ticketshop-ve.png" alt="TicketShop VE">
          <p>Música <b>|</b> Eventos <b>|</b> Grandes momentos</p>
        </div>
      </div>
    </section>

    <!-- TODOS LOS EVENTOS -->
    <section class="ts-container ts-section" id="eventos">
      <div class="ts-section-head">
        <h2 class="ts-title ts-title-sm">
          <template v-if="busqueda">Resultados para <span>"{{ busqueda }}"</span></template>
          <template v-else>Todos los <span>eventos</span></template>
        </h2>
        <a v-if="busqueda" href="#" class="ts-ver-todos" @click.prevent="limpiarBusqueda">
          Limpiar búsqueda <i class="material-icons">close</i>
        </a>
      </div>

      <div class="ts-filtros" v-if="!busqueda">
        <v-select
          v-model="tiposEventosFilter"
          :items="tiposEventos"
          item-text="nombre"
          item-value="id"
          multiple
          small-chips
          outlined
          dense
          hide-details
          label="Tipo de evento"
        ></v-select>
        <v-select
          v-model="artistasFilter"
          :items="artistas"
          item-text="nombre"
          item-value="id"
          multiple
          small-chips
          outlined
          dense
          hide-details
          label="Artista"
        ></v-select>
        <label class="ts-fecha-input">
          <span>Desde</span>
          <input type="date" v-model="desde">
        </label>
        <label class="ts-fecha-input">
          <span>Hasta</span>
          <input type="date" v-model="hasta">
        </label>
        <button type="button" class="ts-btn-filtrar" @click="filterEventos(1)">Filtrar</button>
      </div>

      <div class="ts-grid" v-if="eventos.length">
        <EventoCard v-for="evento in eventos" :key="'ev-' + evento.id" :evento="evento"></EventoCard>
      </div>
      <div v-else class="ts-vacio">
        <i class="material-icons">event_busy</i>
        <p>No se encontraron eventos.</p>
      </div>

      <div class="ts-paginacion" v-if="!busqueda && pagesEventos > 1">
        <v-pagination
          :value="paginationEventos.page"
          :length="pagesEventos"
          color="#c8962e"
          @input="cambiarPagina"
        ></v-pagination>
      </div>
    </section>

    <!-- EVENTOS POR CIUDAD -->
    <section class="ts-container ts-section" id="ciudades">
      <div class="ts-section-head">
        <h2 class="ts-title ts-title-sm">Eventos <span>por ciudad</span></h2>
      </div>
      <div class="ts-ciudades">
        <a
          v-for="ciudad in ciudades"
          :key="ciudad.slug"
          href="#"
          class="ts-ciudad"
          :style="{ backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,.85) 100%), url(/images/ciudades/' + ciudad.slug + '.jpg), linear-gradient(135deg, ' + ciudad.color + ', #111)' }"
          @click.prevent="buscarCiudad(ciudad.nombre)"
        >
          <span>{{ ciudad.nombre }}</span>
        </a>
      </div>
    </section>
  </v-app>
</template>
<script>
import Carousel from "./fragments/Carousel.vue";
import EventoCard from "./fragments/EventoCard.vue";

export default {
  components: {
    Carousel,
    EventoCard,
  },
  async beforeCreate() {
    this.$store.dispatch("tipoevento/listTipoEvento", 1);
    this.$store.dispatch("artista/listArtistasActive", 1);
    this.$store.dispatch("evento/bannersDestacados");
  },
  async created() {
    document.title = "Inicio - TicketShop";
    // Se marca como cargado al responder la API, haya o no eventos (la acción captura sus propios errores)
    this.$store.dispatch("evento/listEventosEstadoBanner").then(() => {
      this.bannersCargados = true;
    });
  },
  mounted() {
    this.cargarEventos();
    if (this.$route.hash) {
      setTimeout(() => this.scrollA(this.$route.hash.replace("#", "")), 600);
    }
  },
  watch: {
    "$route.query.q"() {
      this.cargarEventos();
    },
  },
  data() {
    return {
      bannersCargados: false,
      desde: null,
      hasta: null,
      artistasFilter: [],
      tiposEventosFilter: [],
      beneficios: [
        { icono: "confirmation_number", titulo: "Compra segura", texto: "Tus boletas 100% garantizadas" },
        { icono: "credit_card", titulo: "Múltiples métodos de pago", texto: "Nacional e internacional" },
        { icono: "verified_user", titulo: "Boletería oficial", texto: "Eventos verificados" },
        { icono: "headset_mic", titulo: "Atención personalizada", texto: "Estamos para ayudarte" },
      ],
      ciudades: [
        { nombre: "Caracas", slug: "caracas", color: "#2e5d8a" },
        { nombre: "San Cristóbal", slug: "san-cristobal", color: "#8a3b2e" },
        { nombre: "Valencia", slug: "valencia", color: "#4a6b2e" },
        { nombre: "Maracaibo", slug: "maracaibo", color: "#a8611d" },
        { nombre: "Barquisimeto", slug: "barquisimeto", color: "#5a3b7a" },
        { nombre: "Maracay", slug: "maracay", color: "#2e7a6b" },
      ],
    };
  },
  computed: {
    busqueda() {
      return (this.$route.query.q || "").trim();
    },
    eventos() {
      // El store invierte el orden de la API; aquí se restaura sin mutar el estado
      return this.$store.getters["evento/listEventos"].slice().reverse();
    },
    proximosEventos() {
      const destacados = this.$store.state.evento.eventos_destacados || [];
      return (destacados.length ? destacados : this.eventos).slice(0, 4);
    },
    bannersDestacados() {
      const data = this.$store.state.evento.dataBannersDestacados;
      if (!data || !data.banners) return [];
      return data.banners.filter(b => b.status == 1);
    },
    tiposEventos() {
      return this.$store.getters["tipoevento/listTipoEvento"];
    },
    artistas() {
      return this.$store.getters["artista/listArtistas"];
    },
    paginationEventos() {
      return this.$store.getters["evento/pagination"];
    },
    pagesEventos() {
      return this.$store.getters["evento/pages"];
    },
    eventosEstadoBanner() {
      return this.$store.getters["evento/listEventosEstadoBanner"];
    },
    cargado() {
      return this.bannersCargados || this.eventosEstadoBanner.length > 0;
    },
    imagenesEventoCarousel() {
      const items = this.eventosEstadoBanner
        .filter(evento => evento.imagens.some(img => img.nombre.includes("banner")))
        .map(evento => ({ imagen: evento }));

      // reordenar al azar
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      return items;
    },
  },
  methods: {
    cargarEventos() {
      if (this.busqueda) {
        this.$store.dispatch("evento/searchEventos", encodeURIComponent(this.busqueda));
      } else {
        this.filterEventos(1);
      }
    },
    filterEventos(page) {
      this.$store.dispatch("evento/filterEventos", {
        page: page,
        precio_inicio: null,
        precio_fin: null,
        artistas: this.artistasFilter,
        tiposEvento: this.tiposEventosFilter,
        fecha_inicio: this.desde,
        fecha_fin: this.hasta,
      });
    },
    cambiarPagina(page) {
      this.filterEventos(page);
      this.scrollA("eventos");
    },
    buscarCiudad(nombre) {
      this.$router.push({ path: "/", query: { q: nombre } }).catch(() => {});
      this.$nextTick(() => this.scrollA("eventos"));
    },
    limpiarBusqueda() {
      this.$router.push({ path: "/" }).catch(() => {});
    },
    scrollA(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style>
.ts-home,
.ts-home .v-application--wrap {
  background: #f3f2ef !important;
}
.ts-home *:not(.material-icons):not(.v-icon):not(.mdi) {
  font-family: 'Montserrat', Raleway, sans-serif;
}
.ts-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
.ts-section {
  padding-top: 40px;
  padding-bottom: 10px;
  scroll-margin-top: 20px;
}
.ts-hero-skeleton .v-skeleton-loader__image {
  height: auto !important;
  aspect-ratio: 2 / 1;
  max-height: 560px;
}

/* Beneficios */
.ts-features {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .08);
  margin-top: -28px;
  position: relative;
  z-index: 2;
  padding: 18px 8px;
}
.ts-feature {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 6px 20px;
}
.ts-feature + .ts-feature {
  border-left: 1px solid #e3e0d8;
}
.ts-feature-icon {
  font-size: 38px !important;
  color: #c8962e;
}
.ts-feature h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #1a1a1a;
}
.ts-feature p {
  margin: 2px 0 0;
  font-size: 12px;
  color: #666;
}

/* Titulos de seccion */
.ts-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.ts-home .ts-title {
  font-family: 'Oswald', sans-serif !important;
  font-size: 42px;
  font-weight: 500;
  text-transform: uppercase;
  color: #111;
  margin: 0;
  line-height: 1;
}
.ts-home .ts-title span {
  font-family: 'Oswald', sans-serif !important;
  font-weight: 700;
  color: #c8962e;
}
.ts-home .ts-title-sm {
  font-size: 30px;
}
.ts-home a.ts-ver-todos {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #b8862a !important;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: .5px;
  white-space: nowrap;
  padding: 6px 14px;
  border: 1.5px solid #d4a537;
  border-radius: 999px;
  transition: background .2s, color .2s;
}
.ts-home a.ts-ver-todos .material-icons {
  font-size: 18px;
}
.ts-home a.ts-ver-todos:hover {
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a !important;
}

/* Grid de eventos */
.ts-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}
.ts-card-skeleton .v-skeleton-loader__image {
  height: auto !important;
  aspect-ratio: 5 / 7;
}

/* Banners destacados */
.ts-destacados {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
  padding-top: 30px;
}
.ts-destacado img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .15);
}

/* Experiencias */
.ts-experiencias {
  margin-top: 50px;
  background:
    linear-gradient(90deg, rgba(0, 0, 0, .55) 0%, rgba(0, 0, 0, .85) 55%, rgba(0, 0, 0, .55) 100%),
    url('/images/fondo-menu.jpg') center / cover;
  border-top: 1px solid rgba(212, 165, 55, .4);
  border-bottom: 1px solid rgba(212, 165, 55, .4);
}
.ts-experiencias-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 36px 24px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 30px;
  flex-wrap: wrap;
}
.ts-home .ts-experiencias-title {
  font-family: 'Oswald', sans-serif !important;
  color: #fff;
  font-size: 58px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: .95;
  margin: 0;
}
.ts-home .ts-experiencias-title span {
  display: block;
  font-family: 'Oswald', sans-serif !important;
  font-style: italic;
  color: #e2b552;
  transform: skewX(-8deg);
  margin-left: 70px;
}
.ts-experiencias-brand {
  text-align: center;
}
.ts-experiencias-brand img {
  max-width: 230px;
}
.ts-experiencias-brand p {
  color: #fff;
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin: 10px 0 0;
}
.ts-experiencias-brand b {
  color: #c8962e;
  margin: 0 8px;
}

/* Filtros */
.ts-filtros {
  display: grid;
  grid-template-columns: 1.3fr 1.3fr 1fr 1fr auto;
  gap: 12px;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 22px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .05);
}
.ts-fecha-input {
  position: relative;
  margin: 0;
}
.ts-fecha-input span {
  position: absolute;
  top: -8px;
  left: 10px;
  background: #fff;
  padding: 0 4px;
  font-size: 11px;
  color: #666;
}
.ts-fecha-input input {
  width: 100%;
  height: 40px;
  border: 1px solid rgba(0, 0, 0, .38);
  border-radius: 4px;
  padding: 0 10px;
  font-size: 14px;
}
.ts-btn-filtrar {
  height: 40px;
  padding: 0 30px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a;
  font-family: 'Oswald', sans-serif !important;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(212, 165, 55, .35);
  transition: transform .2s, box-shadow .2s;
}
.ts-btn-filtrar:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(212, 165, 55, .5);
}
.ts-vacio {
  text-align: center;
  color: #8c8c8c;
  padding: 50px 0;
}
.ts-vacio .material-icons {
  font-size: 70px;
}
.ts-paginacion {
  padding-top: 24px;
}

/* Ciudades */
.ts-ciudades {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  padding-bottom: 30px;
}
.ts-ciudad {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  aspect-ratio: 4 / 3;
  border-radius: 8px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  padding-bottom: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .15);
  transition: transform .25s;
}
.ts-ciudad:hover {
  transform: translateY(-3px);
}
.ts-ciudad span {
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: .5px;
}

@media (max-width: 1024px) {
  .ts-features,
  .ts-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .ts-feature:nth-child(3) {
    border-left: 0;
  }
  .ts-ciudades {
    grid-template-columns: repeat(3, 1fr);
  }
  .ts-filtros {
    grid-template-columns: 1fr 1fr;
  }
  .ts-btn-filtrar {
    grid-column: span 2;
  }
}
@media (max-width: 600px) {
  .ts-container {
    padding: 0 16px;
  }
  .ts-features {
    grid-template-columns: 1fr;
    margin-top: 16px;
  }
  .ts-feature + .ts-feature {
    border-left: 0;
    border-top: 1px solid #e3e0d8;
  }
  .ts-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .ts-ciudades {
    grid-template-columns: repeat(2, 1fr);
  }
  .ts-filtros {
    grid-template-columns: 1fr;
  }
  .ts-btn-filtrar {
    grid-column: auto;
  }
  .ts-home .ts-title {
    font-size: 30px;
  }
  .ts-home .ts-title-sm {
    font-size: 24px;
  }
  .ts-home .ts-experiencias-title {
    font-size: 40px;
  }
  .ts-home .ts-experiencias-title span {
    margin-left: 30px;
  }
}
</style>
